var _defs, _rect, _g, _g2, _g3, _g4, _g5, _circle, _circle2, _path, _circle3, _g6, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVintageMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 600",
    width: 800,
    height: 600,
    role: "img",
    "aria-label": "Decorative vintage map",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paper",
    cx: "42%",
    cy: "40%",
    r: "80%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fdf6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#f7ead0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#efdfbe"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "plotGlow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fad2a2",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#fad2a2",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fad2a2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "vignette",
    cx: "50%",
    cy: "48%",
    r: "74%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#3d1b04",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3d1b04",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("filter", {
    id: "grain"
  }, /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: 0.9,
    numOctaves: 2,
    seed: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.38  0 0 0 0 0.18  0 0 0 0 0.04  0 0 0 0.03 0"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#paper)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 410 C 70 398 120 446 210 450 C 300 454 330 506 332 600 L 0 600 Z",
    fill: "#9db8ad",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 470 C 80 462 130 486 185 488",
    fill: "none",
    stroke: "#6f9085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 512 C 75 504 135 528 200 530",
    fill: "none",
    stroke: "#6f9085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 556 C 100 548 160 568 235 570",
    fill: "none",
    stroke: "#6f9085",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.35
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6b7d3a",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610 70 q 60 -18 96 22 q 22 52 -28 78 q -64 16 -86 -34 q -10 -46 18 -66 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 170,
    r: 46
  }), /*#__PURE__*/React.createElement("rect", {
    x: 556,
    y: 470,
    width: 120,
    height: 84,
    rx: 16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#7a4a1f",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 64,
    width: 78,
    height: 56,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 60,
    width: 64,
    height: 56,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 132,
    width: 58,
    height: 64,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 132,
    width: 84,
    height: 64,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 120,
    width: 70,
    height: 60,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 552,
    y: 200,
    width: 66,
    height: 58,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 210,
    width: 64,
    height: 48,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 330,
    width: 74,
    height: 60,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318,
    y: 334,
    width: 60,
    height: 56,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 332,
    width: 86,
    height: 58,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 330,
    width: 58,
    height: 62,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 232,
    width: 60,
    height: 64,
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 250,
    width: 70,
    height: 120,
    rx: 9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 690,
    y: 430,
    width: 74,
    height: 70,
    rx: 9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6b4d2e",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 64 L 220 410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 60 L 300 408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 56 L 400 600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 80 L 462 408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 110 L 548 408"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 250 L 770 250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 322 L 770 322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 156 L 560 156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676 60 L 676 560"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6b4d2e",
    strokeWidth: 6.5,
    strokeLinecap: "round",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-10 120 Q 200 100 400 118 T 810 110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 300 Q 220 286 430 300 T 810 300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 470 Q 210 458 430 472 T 810 462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 -10 Q 134 200 150 400 T 142 610"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 -10 Q 416 200 400 400 T 404 610"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 -10 Q 656 200 640 400 T 648 610"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 300,
    r: 26,
    fill: "none",
    stroke: "#6b4d2e",
    strokeWidth: 6.5,
    opacity: 0.24
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 640,
    cy: 300,
    r: 9,
    fill: "#6b7d3a",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M404 600 Q 360 470 392 392 Q 408 352 400 300",
    fill: "none",
    stroke: "#c46d4f",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeDasharray: "0.5 12",
    opacity: 0.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 292,
    r: 78,
    fill: "url(#plotGlow)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(706 96)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    r: 40,
    fill: "none",
    stroke: "#6b4d2e",
    strokeWidth: 2,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    r: 31,
    fill: "none",
    stroke: "#6b4d2e",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -38 L 7 0 L 0 38 L -7 0 Z",
    fill: "#c46d4f",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38 0 L 0 -7 L 38 0 L 0 7 Z",
    fill: "#6b4d2e",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#3d1b04"
  }), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: -46,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 16,
    fill: "#622f0a",
    fontWeight: 700
  }, "N"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "url(#vignette)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    filter: "url(#grain)",
    opacity: 0.28
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVintageMap);
export default __webpack_public_path__ + "static/media/vintage-map.a901f10aae18983484b9cc612ffa6d31.svg";
export { ForwardRef as ReactComponent };